const siqa = {
  RegistrarQueja: "SIQA/RegistrarQueja",
  ActualizarQueja: "SIQA/ActualizarQueja",
  GetReporteQuejasAdministrativas: "SIQA/GetReporteQuejasAdministrativas",
  GuardarDatosDeSentencia: "SIQA/GuardarDatosDeSentencia",
  ObtenerQuejaAdministrativa: "SIQA/ObtenerQuejaAdministrativa",
  CancelarQuejaAdministrativa: "SIQA/CancelarQuejaAdministrativa"
}
export default siqa;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIQA/funcion/siqa.js
// module id = null
// module chunks = 